export const getEmailValue = (emailString) => {
  const isRaychatEmail = emailString?.split("@")[1] === "raychat.ir";

  if (isRaychatEmail) {
    return "";
  }

  return emailString;
};
